// extracted by mini-css-extract-plugin
module.exports = {"topic":"Topic_topic__3eT0c","skill0":"Topic_skill0__3RGxP","skill1":"Topic_skill1__3XQyZ"};